import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EleicaoService } from 'src/app/services/eleicao.service'
import { BlacklistService } from 'src/app/services/blacklist.service'
import { Blacklist } from 'src/app/models/blacklist.model'
import { BlacklistCsvDTO } from 'src/app/models/blacklistCsvDTO.model';
import { Utils } from 'src/app/utils/utils';

@Component({
  selector: 'cadastro-blacklist',
  templateUrl: './blacklist.component.html',
  styleUrls: ['./blacklist.component.css']
})
export class BlacklistComponent implements OnInit {
  public newBlacklistArray: BlacklistCsvDTO[] = [];

  formCadastroBlacklists: FormGroup;
  idEleicao: any;
  token: any;
  listaBlacklist: any;
  novoLoginBlacklist: any;
  newBlacklistDTO: BlacklistCsvDTO = new BlacklistCsvDTO();

  constructor(
    public eleicaoService: EleicaoService,
    public blacklistService: BlacklistService,
    public utils: Utils,
    protected messageService: MessageService
  ) { }

  async ngOnInit() {
    this.novoLoginBlacklist = new Blacklist();
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.token = sessionStorage.getItem("token");
    this.formCadastroBlacklists = new FormGroup({
      login: new FormControl()
    })

    await this.blacklistService.getBlackListByEleicaoId(this.token, this.idEleicao).then((res: []) => {
      if (res.length > 0) {
        this.listaBlacklist = res;
      } else {

      }
    })
  }

  public atualizaLoginNaBlacklist(login, loginId) {
    this.blacklistService.atualizaLoginNaBlacklist(this.token, login, loginId).then(data => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Login atualizado na blacklist com sucesso!' });
      this.formCadastroBlacklists.reset();
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
      this.formCadastroBlacklists.reset();

    })
  }

  // public inserirLoginsNaBlackListEmMassa(event: any) {
  //   let csvFilePath = event.target.value
  //   this.blacklistService.inserirLoginsNaBlackListEmMassa(this.token, listaLogin).then(() => {
  //     this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Blacklist inserida com sucesso!' });
  //     setTimeout(function () {
  //       window.location.reload();
  //     })
  //   }, error => {
  //     this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
  //   })
  // }

  public envioLoginBlacklist() {
    if (this.validarCampoBlackList()) {
      this.novoLoginBlacklist.login = this.formCadastroBlacklists.get("login").value;
      this.novoLoginBlacklist.eleicaoId = this.idEleicao;

      this.blacklistService.inserirLoginNaBlacklist(this.token, this.novoLoginBlacklist).then(data => {
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Login inserido na blacklist com sucesso!' });
        setTimeout(function () {
          window.location.reload();
        })
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
      })
    }
  }

  public excluirDaBlacklist(blacklistId) {
    this.blacklistService.deletaLoginNaBlacklist(this.token, blacklistId).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Login excluído na blacklist com sucesso!' });
      setTimeout(function () {
        window.location.reload();
      })
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
    })
  }

  baixarTemplate() {
    let csvHeader = 'logins'
    this.utils.baixarModeloCsv(csvHeader, "blacklist")
  }

  // CSV
  importarCsv(event) {

    let arquivos = event.srcElement.files;

    if (this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);

      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.newBlacklistArray = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length, this.idEleicao);
      };
    }
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any, eleicaoId: number) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let currentRecord = csvRecordsArray[i];
      if (currentRecord.length != 0) {
        let csv: BlacklistCsvDTO = new BlacklistCsvDTO();
        csv.login = currentRecord;
        csv.eleicaoId = eleicaoId;
        csvArr.push(csv);
      }
    }
    return csvArr
  }
  private async insercaoEmMassa(blacklist: BlacklistCsvDTO[]) {
    await this.blacklistService.inserirLoginsNaBlackListEmMassa(this.token, blacklist).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Blacklist enviada com sucesso!' });
      setTimeout(function () {
        window.location.reload();
      })
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: '', detail: error });
    });
  }
  validarCampoBlackList() {
    if (this.formCadastroBlacklists.get("login").value == null || this.formCadastroBlacklists.get("login").value == '') {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário informar o login para a blacklist.' });
      return false;
    } else {
      return true;
    }
  }

  zerarInputFile(element) {
    this.newBlacklistArray = [];
    element.value = '';
  }
  importarList() {
    this.insercaoEmMassa(this.newBlacklistArray);
  }
}


